/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Membersinviteqralt3Inputs */

const en_membersinviteqralt3 = /** @type {(inputs: Membersinviteqralt3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QR code to join ${i?.name}`)
};

const de_membersinviteqralt3 = /** @type {(inputs: Membersinviteqralt3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`QR-Code zum Beitreten bei ${i?.name}`)
};

/**
* | output |
* | --- |
* | "QR code to join {name}" |
*
* @param {Membersinviteqralt3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const membersinviteqralt3 = /** @type {((inputs: Membersinviteqralt3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membersinviteqralt3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_membersinviteqralt3(inputs)
	return de_membersinviteqralt3(inputs)
});
export { membersinviteqralt3 as "membersInviteQrAlt" }